import { useCallback } from 'react';
import type { PointerEvent } from 'react';

/**
 * Cursor-tracking spotlight for glass surfaces. Returns a pointer-move
 * handler that writes the cursor position into the `--mx` / `--my` custom
 * properties on the hovered element; `.glass-surface--interactive::before` reads
 * them to place a radial highlight. No-op when `enabled` is false.
 *
 * Design-system helper — kept generic so any module can reuse it, not just the
 * dashboard. Touches only style props, so it stays on the compositor thread.
 */
export function useSpotlight(enabled = true) {
  return useCallback(
    (event: PointerEvent<HTMLElement>) => {
      if (!enabled) return;
      const el = event.currentTarget;
      const rect = el.getBoundingClientRect();
      el.style.setProperty('--mx', `${((event.clientX - rect.left) / rect.width) * 100}%`);
      el.style.setProperty('--my', `${((event.clientY - rect.top) / rect.height) * 100}%`);
    },
    [enabled],
  );
}
